module.exports = __webpack_public_path__ + "7d088296/img/menu-icon.5f8facae.svg";